import { render } from "./Spinner.vue?vue&type=template&id=7b4dedb8&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=7b4dedb8&scoped=true&lang=css"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4dedb8"]])

export default __exports__